import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class BusinessForwardSearchItem extends Component {
  constructor(props) {
    super(props);
    this.handleChoose = this.handleChoose.bind(this);
  }

  static propTypes = {
    onChoose: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isCanNotChoose: PropTypes.bool.isRequired
  }

  static defaultProps = {
    data: {},
    isCanNotChoose: false
  }

  handleChoose = () => {
    if (!this.props.data || !this.props.data.id) {
      return;
    }
    this.props.onChoose && this.props.onChoose(this.props.data.id);
  }

  render() {
    const { data, index } = this.props;
    if (!data) {
      return null;
    }

    return (
      <tr className="tr">
        <td className="td col-lg-1">
          {index}
        </td>
        <td className="td col-lg-8">{data.name}</td>
        <td className="td col-lg-3 text-center">
          <button
            className="btn btn-primary"
            type="button"
            onClick={this.handleChoose}
            disabled={this.props.isCanNotChoose}
            >
            Chọn
          </button>
        </td>
      </tr>
    );
  }
}

export default BusinessForwardSearchItem;


// WEBPACK FOOTER //
// ./components/business/BusinessForwardSearchItem.jsx